import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../i18n';
import { ShareIcon } from '@wix/wix-vod-shared/icons';

import styles from './styles.scss';

const ShareButton = ({ onClick }) => (
  <button
    className={styles.share}
    tabIndex="0"
    title={i18n.t('accessibility.share-button')}
    aria-label={i18n.t('accessibility.share-button')}
    onClick={onClick}
  >
    <ShareIcon />
  </button>
);

ShareButton.propTypes = {
  onClick: PropTypes.func,
};

export default ShareButton;
